/**
* Inspire-hub 2 (www.giap.pl)
*
* Copyright © GIAP sp.z.o.o. All rights reserved.
*
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
*/
/* eslint-disable max-len */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../../../components/GrayPanel';
import Paper from '../../../../components/Paper';
import FormRow from '../../../../components/FormRow';
import ModalAlert from '../../../../components/ModalAlert';
import Select from 'react-select';

import { adminEndpoint } from '../../../../config';
import fetch from '../../../../core/fetch';
import s from './AddDistrict.css';

const btnStyles = { margin: '10px' };

class AddDistrict extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  redirectURL = `${adminEndpoint}/districts`;
  postServiceURL = `${process.env.API_URL}/districts/addDistrict`;

  initialState = {
    prefix: null,
    name: null,
    placeOfSettling: null,
    place: null,
    street: null,
    nrBuilding: null,
    nrLocal: null,
    zipCode: null,
    phone: null,
    fax: null,
    pageWWW: null,
    pageBIP: null,
    email: null,
    teryt: null,
    description: null,
    showModal: false,
    modalTitle: '',
    modalText: '',
    shouldRedirect: false,
    selectedOption: '',
  }

  state = this.initialState;

  postDistrictURL = `${process.env.API_URL}/app_district`;
  getDistrict = `${process.env.API_URL}/prefix/`; // <string:prefix>

  onChange = (e, callback = null) => this.setState({ [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }, callback);
  onHide = () => this.setState({ showModal: false }, () => {
    if (this.state.shouldRedirect) {
      window.location.href = this.redirectURL;
    }
  });

  handleChange = (selectedOption) => this.setState({ selectedOption }, ()  => {
    fetch(`${this.getDistrict}${this.state.selectedOption.value}`)
    .then(resp => {
      if (resp.status === 200) {
        return resp.json();
      } else throw resp;
    })
    .then(r => {
      this.setState({ ...this.initialState }, () => {
        this.setState({
          pageWWW: r.www,
          pageBIP: r.bip,
          prefix: r.prefix,
          name: r.nazwa,
        }, () => {
          if (Object.keys(this.props.districts).indexOf(r.prefix) > -1 ) {
            const d = this.props.districts[r.prefix];
            this.setState({
              prefix: d.prefix,
              name: d.nazwa,
              placeOfSettling: d.miejsceZalatwienia,
              place: d.miejscowosc,
              street: d.ulica,
              nrBuilding: d.nrBudynku,
              nrLocal: d.nrLokalu,
              zipCode: d.kod,
              phone: d.telefon,
              fax: d.faks,
              pageWWW: d.strona,
              pageBIP: d.stronaBIP,
              email: d.email,
              teryt: d.teryt,
            });
          }
        });
      });
    });
  });

  add = () => {
    fetch(this.postDistrictURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...this.state }),
    })
    .then(resp => {
      if (resp.status == 200) {
        return resp.json();
      } else {
        throw resp;
      }
    })
    .then(r => {
      this.setState({ modalText: "Pomyślnie dodano gminę", modalTitle: "Status dodawania gminy", shouldRedirect: true, showModal: true });
    })
    .catch(async err => {
      let text = await err.text();
      this.setState({ modalText: "Błąd przy dodawaniu gminy: \n" + text, modalTitle: "Błąd", shouldRedirect: false, showModal: true });
    });
  }

  render() {
    const { selectedOption } = this.state;
    const value = selectedOption && selectedOption.value;

    return (
      <Paper title={this.props.title}>
        <div className="row">
          <div className="col-sm-2" />
          <div className="col-sm-8">
            <hr />
            <Select
              name="form-field-name"
              value={value}
              onChange={this.handleChange}
              options={this.props.prefixes ? this.props.prefixes.map(v => { return { value: v, label: v }}) : []}
            />
            <FormRow label="Nazwa" name="name" onChange={e => this.onChange(e)} value={this.state.name} />
            <FormRow label="Miejsce załatwienia" name="placeOfSettling" onChange={e => this.onChange(e)} value={this.state.placeOfSettling} />
            <FormRow label="Miejscowość" name="place" onChange={e => this.onChange(e)} value={this.state.place} />
            <FormRow label="Ulica" name="street" onChange={e => this.onChange(e)} value={this.state.street} />
            <FormRow label="Numer budynku" name="nrBuilding" onChange={e => this.onChange(e)} value={this.state.nrBuilding} />
            <FormRow label="Numer lokalu" name="nrLocal" onChange={e => this.onChange(e)} value={this.state.nrLocal} />
            <FormRow label="Kod pocztowy" name="zipCode" onChange={e => this.onChange(e)} value={this.state.zipCode} />
            <FormRow label="Telefon" name="phone" onChange={e => this.onChange(e)} value={this.state.phone} />
            <FormRow label="Fax" name="fax" onChange={e => this.onChange(e)} value={this.state.fax} />
            <FormRow label="Strona www" name="pageWWW" onChange={e => this.onChange(e)} value={this.state.pageWWW} />
            <FormRow label="Strona BIP" name="pageBIP" onChange={e => this.onChange(e)} value={this.state.pageBIP} />
            <FormRow label="Oficjalny email" name="email" onChange={e => this.onChange(e)} value={this.state.email} />
            <FormRow label="Teryt" name="teryt" onChange={e => this.onChange(e)} value={this.state.teryt} />
            <FormRow label="Opis" name="description" onChange={e => this.onChange(e)} value={this.state.description} />

            <hr />
            <div className="pull-right">
              <a href={this.redirectURL} style={btnStyles} className="btn btn-danger">Anuluj</a>
              <button type="submit" onClick={() => this.add()} style={btnStyles} className="btn btn-primary">Dodaj</button>
            </div>
          </div>
          <div className="col-sm-2" />
        </div>
        <ModalAlert
          title={this.state.modalTitle}
          bodyText={this.state.modalText}
          show={this.state.showModal}
          name="statusModal"
          onHide={() => this.onHide()}
        />
      </Paper>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts
});

const mapDispatch = {};

export default withStyles(s)(connect(mapState, mapDispatch)(AddDistrict));



// WEBPACK FOOTER //
// src/routes/admin/districts/add_district/AddDistrict.js